import { useEffect, useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from 'antd';
import { useUpdataOfferTitleMutation } from 'services';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { fetchError } from 'slices/commonSlice';
import { openNotification } from 'utils';

/**
 * Madde başlığını gösterir; yetki varsa yanında düzenleme (kalem) butonu ve başlık düzenleme modalını render eder.
 * @param {Object} props
 * @param {string} props.title - Madde başlığı
 * @param {number} props.offerId - Madde teklifi numeric ID'si (`PATCH /article_offers/{id}/title`)
 * @param {boolean} [props.isShowEditButton=false] - Düzenleme butonu render edilsin mi. Yetki kararı
 *   çağıranda verilir (`useArticleTitleEditPermission`); bu bileşen kural bilmez.
 */
function EditableTitle({ title, offerId, isShowEditButton = false }) {
  const [form] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);
  const [updateOfferTitle] = useUpdataOfferTitleMutation();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const onFinish = async (values) => {
    const title = values.title;
    const { error } = await updateOfferTitle({
      id: offerId,
      body: {
        title: title,
      },
    });
    if (error) {
      return dispatch(
        fetchError(
          formatMessage(
            {
              id: 'article.form.fetchError',
            },
            { error: error.status }
          )
        )
      );
    }
    openNotification({
      message: formatMessage({ id: 'appModule.actionSuccessfully' }),
    });
    form.resetFields();
    setOpenModal(false);
  };

  useEffect(() => {
    form.setFieldsValue({ title });
  }, [title, form]);

  return (
    <>
      <span
        className="gx-d-flex gx-align-items-center gx-justify-content-between"
        style={{
          gap: 6,
        }}
      >
        <h2
          className="gx-h1-lg"
          style={{
            transform: 'translateY(2px)',
          }}
        >
          {title}
        </h2>
        {/*
          Yetki yoksa buton hiç render EDİLMEZ — `display: none` ile gizlenmesi butonu DOM'da ve
          `onClick`'i bağlı bırakıyordu, CSS'i değiştiren biri modalı açıp istek atabiliyordu.
        */}
        {isShowEditButton && (
          <Button
            type="text"
            shape="circle"
            onClick={() => setOpenModal(true)}
          >
            <EditOutlined />
          </Button>
        )}
      </span>
      <Modal
        open={openModal}
        onCancel={() => setOpenModal(false)}
        okText="Kaydet"
        cancelText="İptal"
        okButtonProps={{ form: 'editableTitleForm', htmlType: 'submit' }}
        destroyOnClose
      >
        <Form
          id="editableTitleForm"
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            name="title"
            label="Madde Başlığı"
            rules={[{ required: true, message: 'Madde Başlığı boş bırakılamaz' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
export default EditableTitle;
